import { createApi } from '@reduxjs/toolkit/query/react';
import { TEMPLATE } from '../../utils/apiEndpoints';
import fetchQuery from '../../apiClient/fetchQuery';

export const templatesApi = createApi({
  reducerPath: 'templatesApi',
  baseQuery: fetchQuery,
  endpoints: (builder) => ({
    fetchAllTemplates: builder.query({
      query: ({ query: query, category: category }) => ({
        url: `${query !== '' ? `${TEMPLATE}/search?&limit=20&query=${query}` : category !== '' ? `${TEMPLATE}/search?&limit=20&category=${category}` : `${TEMPLATE}/search?&limit=20&query=${query}`}`,
      }),
      transformResponse: (response) => ({
        templates: response,
      }),
    }),
    getTemplatesCategory: builder.query({
      query: () => ({
        url: `${TEMPLATE}/categories`,
      }),
      transformResponse: (response) => ({
        categories: response,
      }),
    }),
    transformTemplate: builder.mutation({
      query: (data) => ({
        url: `${TEMPLATE}/transform`,
        method: 'PUT',
        data: data,
      }),
      transformResponse: (response) => ({
        response: response,
      }),
    }),
  }),
});

export const { useLazyFetchAllTemplatesQuery, useLazyGetTemplatesCategoryQuery, useTransformTemplateMutation } =
  templatesApi;
